
































import Vue, { PropOptions } from 'vue';
import { routes } from '@/router';
import * as models from '@/class/models/views/app';
import NOC from '@/class/common/const';
import * as NOCArray from '@/personal/array';


export default Vue.extend({
  name: 'SideBar',
  props: {
    nowPath: String,
    ownerFlag : Boolean,
  },
  data() {
    return {
      sidebarShowFlag: false,
      settingsShowFlag: false,
      settingsClassFlag: false,
      settingsChildren: [
        { to: '/setting/work_style', name: '就業形態管理'},
        // { to: '/setting/black_list', name: '除外リスト管理'},
        { to: '/setting/users', name: 'ユーザー管理'},
        // { to: '/setting/account', name: 'ご契約情報'},
      ],
      IconDashboard: '',
      IconGraph: '',
      IconSetting: '',
    };
  },
  mounted() {
    // 初期表示時はpropsの値を確認
    switch (this.nowPath) {
      case '/account':
      case '/contact':
        this.sidebarShowFlag = false;
        break;
      default:
        this.sidebarShowFlag = true;
        break;
    }
    this.onChangeDispImg(location.pathname.toString());
  },
  watch: {
    nowPath(newInput) {
      // console.log('nowPath', newInput);
      switch (newInput) {
        case '/account':
        case '/contact':
          this.sidebarShowFlag = false;
          break;
        default:
          this.sidebarShowFlag = true;
          break;
      }
      this.onChangeDispImg(newInput);
    },
  },
  methods: {
    // 設定欄を表示
    onChangeSettings(flag: boolean) {
      if (location.href.toString().indexOf('setting/') > 0) {
        flag = true;
      }
      this.settingsShowFlag = flag;
    },
    onChangeDispImg(value: string) {
      this.IconDashboard = '/images/sidebar/dashboard_off.png';
      this.IconGraph = '/images/sidebar/graph_off.png';
      this.IconSetting = '/images/sidebar/setting_off.png';
      this.settingsClassFlag = false;
      // locationが
      if (value === ('/')) {
        this.IconDashboard = '/images/sidebar/dashboard_on.png';
        this.onChangeSettings(false);
      }
      if (value === ('/graph')) {
        this.IconGraph = '/images/sidebar/graph_on.png';
        this.onChangeSettings(false);
      }
      if (value.indexOf('setting') >= 0) {
        this.IconSetting = '/images/sidebar/setting_on.png';
        this.settingsClassFlag = true;
        this.settingsShowFlag = true;
      }
      this.$emit('pushPath', value);
    },
  },
});

